/* eslint-disable max-len */
import axios from 'axios';
import {smallNotification} from '@shared/services/gf.notification.service';
import helper from './helper.service';
import store from '../../store';
import {FORM_NAME_ENUMS} from '../variables/form-name.enums';

let controller = new AbortController();
let isBranchesDiffCall = false;

let mergeRequestDiffController = new AbortController();
let isMergeRequestDiffCall = false;

export default {
  rebaseSourceBranch(alias, projectAlias, mergeRequestId) {
    return axios
        .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/rebase-source-branch`)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          smallNotification('danger', { title: 'Произошла ошибка' });
          console.error(err);
        })
  },
  getMergeRequestDescriptionTemplate(alias, projectAlias) {
    return axios
        .get(`/api/project/${alias}/${projectAlias}/setting/approver/merge-request-description`)
        .then((res) => {
          return res.data
        })
        .catch((err) => {
          smallNotification('danger', {title: 'Произошла ошибка'})
          throw err
        })
  },
  getMergeRequests(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/list`, {
        params: { ...helper.getRealPagination(params) }
      })
      .then((res) => store && store.dispatch('setMergeRequests', helper.parsePagination(res.data)))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getMergeRequestsItem(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}`, params)
      .then((res) => {
        if (store) store.dispatch('selectMergeRequest', res.data);
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  // eslint-disable-next-line no-shadow
  getMergeRequestsItemUuid(store, alias, projectAlias, mergeRequestUuid) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestUuid}`)
      .then((res) => store && store.dispatch('selectMergeRequest', res.data))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  createMergeRequest(alias, projectAlias, data) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request`, data, {
        formName: FORM_NAME_ENUMS.MERGE_REQUEST_FORM
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  editMergeRequest(alias, projectAlias, mergeRequestId, data) {
    return axios
      .put(
        `/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}`,
        {
          id: mergeRequestId,
          ...data
        },
        {
          formName: FORM_NAME_ENUMS.MERGE_REQUEST_FORM
        }
      )
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getMergeRequestsDiscussions(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/discussion/merge-request/${mergeRequestId}`, {
        params
      })
      .then((res) => store && store.dispatch('setMergeRequestDiscussions', res.data))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getMergeRequestsDiffDiscussions(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(
        `/api/project/${alias}/${projectAlias}/discussion/merge-request/${mergeRequestId}/diff`,
        { params }
      )
      .then((res) => store && store.dispatch('setMergeRequestDiscussions', res.data))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getBranchesDiff(alias, projectAlias, baseBranch, compareBranch, sourceProjectId) {
    if (isBranchesDiffCall) {
      controller.abort();
      controller = new AbortController();
      isBranchesDiffCall = false;
    }
    isBranchesDiffCall = true;
    store.dispatch('setBranchDiff', null);
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch/compare`, {
        params: { base: baseBranch, compare: compareBranch, sourceProjectId },
        signal: controller.signal
      })
      .then((res) => {
        store.dispatch('setBranchDiff', res.data);
        isBranchesDiffCall = false;
      })
      .catch((err) => {
        if (err?.code !== 'ERR_CANCELED') {
          smallNotification('danger', { title: 'Произошла ошибка' });
        }
        isBranchesDiffCall = false;
        throw err;
      });
  },
  getMergeRequestDiff(alias, projectAlias, mergeRequestId, params) {
    if (isMergeRequestDiffCall) {
      mergeRequestDiffController.abort();
      mergeRequestDiffController = new AbortController();
      isMergeRequestDiffCall = false;
    }
    isMergeRequestDiffCall = true;
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/compare`, {
        params,
        signal: mergeRequestDiffController.signal
      })
      .then((res) => {
        store.dispatch('setMergeRequestDiff', {
          commitBlobModelMap: res.data?.commitBlobModelMap,
          diffType: params.type
        });
        isMergeRequestDiffCall = false;
        store.dispatch('setMergeRequestsLinesCounters', {
          mergeRequestId,
          linesData: {
            addedLinesInAllFiles: res?.data?.addedLinesInAllFiles,
            removedLinesInAllFiles: res?.data?.removedLinesInAllFiles
          }
        });
      })
      .catch((err) => {
        if (err?.code !== 'ERR_CANCELED') {
          smallNotification('danger', { title: 'Произошла ошибка' });
        }
        isMergeRequestDiffCall = false;
        throw err;
      });
  },
  getBranchesCommits(alias, projectAlias, baseBranch, compareBranch, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch/commit`, {
        params: { baseHash: baseBranch, compareHash: compareBranch, ...params }
      })
      .then((res) => store && store.dispatch('setBranchCommits', res.data))
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  createDiscussion(alias, projectAlias, data) {
    return axios
      .post(`/project/${alias}/${projectAlias}/discussion/create`, {
        resolved: false,
        type: 'MERGE_REQUEST_COMMENT',
        ...data
      })
      .then((res) => {
        // eslint-disable-next-line no-unused-expressions
        store &&
          store.dispatch(
            data.discussionUuid ? 'addMergeRequestReply' : 'addMergeRequestDiscussion',
            res.data
          );
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  deleteIssueReply(userAlias, projectAlias, localId, discussionUuid) {
    return axios
      .post(
        `/api/project/${userAlias}/${projectAlias}/discussion/${localId}/${discussionUuid}/delete`
      )
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  resolveDiscussion(alias, projectAlias, mergeRequestId, discussion) {
    return axios
      .put(
        `/project/${alias}/${projectAlias}/discussion/${mergeRequestId}/${discussion.id}/resolve`,
        {}
      )
      .then(() => store && store.dispatch('resolveDiscussion', discussion))
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  mergeMergeRequest(alias, projectAlias, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/merge`)
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  closeMergeRequest(alias, projectAlias, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/close`)
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  cancelMergeRequest(alias, projectAlias, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/cancel`)
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getMergeRequestCodeOwners(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/codeowners`, {
        params
      })
      .then((res) => {
        store.dispatch('setCodeOwners', res.data);
        return res.data;
      });
  },
  getMergeRequestPipelines(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/pipeline`, {
        params: { ...helper.getRealPagination(params) }
      })
      .then((res) => {
        const dataWithSortedStages = helper.parsePagination(res.data);
        dataWithSortedStages.items.forEach((item) => {
          item.stages.sort((a, b) => a.position - b.position);
        });

        store.dispatch('setMergeRequestPipeline', dataWithSortedStages);
        store.dispatch('setPipelineIsCreating', false);
        return helper.parsePagination(res.data);
      });
  },
  restartMergeRequestPipeline(alias, projectAlias, id, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/restart`, {})
      .then(() => this.getMergeRequestPipelines(alias, projectAlias, mergeRequestId));
  },
  cancelMergeRequestPipeline(alias, projectAlias, id, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/cancel`)
      .then(() => this.getMergeRequestPipelines(alias, projectAlias, mergeRequestId));
  },
  deleteMergeRequestPipeline(alias, projectAlias, id, mergeRequestId) {
    return axios
      .delete(`/api/project/${alias}/${projectAlias}/cicd/pipeline/${id}/delete`)
      .then(() => this.getMergeRequestPipelines(alias, projectAlias, mergeRequestId));
  },
  startMergeRequestPipeline(alias, projectAlias, mergeRequestId) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/pipeline`)
      .then(() => {
        store.dispatch('setPipelineIsCreating', true);
        this.getMergeRequestPipelines(alias, projectAlias, mergeRequestId);
      });
  },
  runMergeResultPipeline(alias, projectAlias, mergeRequestId) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/results-pipeline`
      )
      .then(() => {
        this.getMergeRequestsItem(alias, projectAlias, mergeRequestId);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  runMergeRequestPipeline(alias, projectAlias, mergeRequestId) {
    return axios
        .post(
            `/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/request-pipeline`
        )
        .then(() => {
          this.getMergeRequestsItem(alias, projectAlias, mergeRequestId);
        })
        .catch((err) => {
          smallNotification('danger', { title: 'Произошла ошибка' });
          throw err;
        });
  },
  getMergeRequestBlames(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/blames`, params)
      .then((res) => res.data)
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  getMergeRequestConflicts(alias, projectAlias, mergeRequestId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/conflict`, {
        params
      })
      .then((res) => {
        store.dispatch('setMergeRequestConflicts', res?.data?.conflictFiles);
        return res?.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        throw err;
      });
  },
  commitResolvedMergeRequestConflicts(alias, projectAlias, mergeRequestId, data) {
    return axios
      .post(
        `/api/project/${alias}/${projectAlias}/merge-request/${mergeRequestId}/conflict`,
        data,
        {
          formName: FORM_NAME_ENUMS.COMMIT_CONFLICTS_FORM
        }
      )
      .then((res) => res?.data)
      .catch((err) => {
        throw err;
      });
  }
};
